var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 8.75005C10.205 8.75005 8.74994 10.2051 8.74994 12C8.74994 13.795 10.205 15.25 11.9999 15.25C13.7949 15.25 15.2499 13.795 15.2499 12C15.2499 10.2051 13.7949 8.75005 11.9999 8.75005Z",
    fill: "#FFD646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76948 3.08151C10.2176 2.69614 13.7823 2.69614 17.2304 3.08151C19.1288 3.29369 20.66 4.78947 20.8828 6.69452C21.2951 10.2195 21.2951 13.7806 20.8828 17.3056C20.66 19.2106 19.1288 20.7064 17.2304 20.9186C13.7823 21.304 10.2176 21.304 6.76948 20.9186C4.87108 20.7064 3.33989 19.2106 3.11707 17.3056C2.70479 13.7806 2.70479 10.2195 3.11707 6.69452C3.33989 4.78947 4.87108 3.29369 6.76948 3.08151ZM16.9999 6.00005C16.4477 6.00005 15.9999 6.44776 15.9999 7.00005C15.9999 7.55233 16.4477 8.00005 16.9999 8.00005C17.5522 8.00005 17.9999 7.55233 17.9999 7.00005C17.9999 6.44776 17.5522 6.00005 16.9999 6.00005ZM7.24994 12C7.24994 9.37669 9.37659 7.25005 11.9999 7.25005C14.6233 7.25005 16.7499 9.37669 16.7499 12C16.7499 14.6234 14.6233 16.75 11.9999 16.75C9.37659 16.75 7.24994 14.6234 7.24994 12Z",
    fill: "#FFD646"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.3ba32fb232a881c7ddbc781a928b14f5.svg";
export { ForwardRef as ReactComponent };